import { render } from "./AddOwnFee.vue?vue&type=template&id=1a0dd98a&scoped=true"
import script from "./AddOwnFee.vue?vue&type=script&lang=js"
export * from "./AddOwnFee.vue?vue&type=script&lang=js"

import "./AddOwnFee.vue?vue&type=style&index=0&id=1a0dd98a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0dd98a"]])

export default __exports__